import React, { memo, useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import { Button } from '@saleshandy/design-system';
import RadioButtonGroup from '../../../../../../../../shared/design-system/components/radio-button-group';
import { CallRecordingIcon } from '../../../../../../../../shared/svg';
import type { IProps } from './types';

const EnableCallRecordingModal: React.FC<IProps> = ({
  show,
  onClose,
  onSubmit,
}) => {
  const [recordingAction, setRecordingAction] = useState<'enable' | 'disable'>('enable');

  // Reset state when modal closes
  useEffect(() => {
    if (!show) {
      setRecordingAction('enable');
    }
  }, [show]);

  const handleConfirm = () => {
    onSubmit?.(recordingAction === 'enable');
    onClose();
  };

  const handleCancel = () => {
    setRecordingAction('enable');
    onClose();
  };

  return (
    <Modal
      show={show}
      onHide={handleCancel}
      aria-labelledby="enable-call-recording-modal-title"
      className="enable-call-recording-modal"
      backdrop="static"
      centered
    >
      <Modal.Header className="enable-call-recording-modal__header">
        <div className="enable-call-recording-modal__header-content">
          <CallRecordingIcon width={20} height={20} className="enable-call-recording-modal__header-icon" />
          <Modal.Title id="enable-call-recording-modal-title" className="enable-call-recording-modal__title">
            Bulk Call Recording Settings
          </Modal.Title>
        </div>
      </Modal.Header>
      <Modal.Body className="enable-call-recording-modal__body">
        <RadioButtonGroup
          name="call-recording-action"
          value={recordingAction}
          onChange={(value) => setRecordingAction(value)}
          className="enable-call-recording-modal__radio-group"
          options={[
            {
              label: 'Enable call recording for all selected numbers',
              value: 'enable',
            },
            {
              label: 'Disable call recording for all selected numbers',
              value: 'disable',
            },
          ]}
        />
      </Modal.Body>
      <Modal.Footer className="enable-call-recording-modal__footer">
        <div className="enable-call-recording-modal__footer-actions">
          <Button
            onClick={handleCancel}
            variant="secondary"
            className="enable-call-recording-modal__cancel-btn"
          >
            Cancel
          </Button>
          <Button
            variant="primary"
            onClick={handleConfirm}
            className="enable-call-recording-modal__confirm-btn"
          >
            Confirm
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default memo(EnableCallRecordingModal);
